import React, { useEffect, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import teamService from "../../Services/TeamService";
import CustomHeading from "../../common/CustomHeading";
const TeamInfo = () => {
  const { teamId } = useParams();
  const [teamData, setTeamData] = useState("");

  useEffect(() => {
    (async () => {
      const teamResponse = await teamService.getTeamData(teamId)
      const teamData = teamResponse.data;
      console.log(teamData);
      setTeamData(teamData);
    })();
  }, [teamId]);

  return (
    <div className="pt-20 mt-1 h-screen w-full bg-appGrayBackground">
      <AdminAppBar />
      <div className="bg-appGrayBackground">
  
        <div className="lg:mx-36 md:mx-24 lg:py-2 md:py-0 lg:pb-6 md:pb-14">
          <div className="flex justify-between pt-8">
            <CustomHeading title="Team Information" isIcon={true} />
          </div>
          <form className="bg-white shadow-md rounded 3xl:w-12/12 3xl:mx-14 md:px-4 lg:px-8 lg:pt-7 md:pt-6 md:pb-4 lg:pb-8 md:mt-8 lg:mt-8 md:mx-0 lg:mx-0 md:mb-4 lg:w-full md:w-full">
            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor="name"
              >
                Name
              </label>
              <input
                className="shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                value={teamData.name}
                readOnly
              />
            </div>

            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor="lead-source"
              >
                BOD
              </label>

              <input
                className="shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                value={teamData?.BOD?.map((obj) => obj.name).join(", ")}
                readOnly
              />
            </div>

            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor="lead-source"
              >
                MD
              </label>

              <input
                className="shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                value={teamData.MD?.name}
                readOnly
              />
            </div>

            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor="members"
              >
                Members
              </label>

              <input
                className="shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                value={teamData?.members?.map((obj) => obj.name).join(", ")}
                readOnly
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TeamInfo;
